import React, { memo } from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import { SpinnerWrapper } from './styles'

const Spinner = ({ size = 100, ...rest }) => (
  <SpinnerWrapper {...rest}>
    <CircularProgress data-testid="spinner-circularProgress" size={size} />
  </SpinnerWrapper>
)

Spinner.propTypes = {
  size: PropTypes.number
}

export default memo(withCommonSnapshotsOnly(Spinner))
